import React from 'react';
import { Button, LeftIcon } from './style';
import RightIcon from '../../../static/img/arrowright-White.svg';

const PurpleBackgroundBtn = ({
  buttonText,
  onClickFn,
  isDisable = false,
  showRightIcon,
  showLeftIcon,
  fontWeight,
}) => {
  return (
    <Button onClick={isDisable ? null : onClickFn} disabled={isDisable} style={{
      fontWeight
    }}>
      {showLeftIcon && <LeftIcon src={RightIcon} />}
      {buttonText}
      {showRightIcon && <img src={RightIcon} />}
    </Button>
  );
};

export default PurpleBackgroundBtn;
